<template>
  <div class="flex items-center space-x-1.5">
    <slot></slot>
  </div>
</template>
